import React, {Component} from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import './informacion.css';
import Alert from 'react-s-alert';
import store from '../../store';

const database=firebase.database();




const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'

  }
};


class Informacion extends  Component{
	
	
	constructor(props){
		
		
		super(props);
		this.state={
			nombre:'',
			direccion:'',
			logo:'',
			mision:'',
			vision:'',
			uploadValue:0,
			files:null,
			template:true
			
		}
		
		
		this.informacionRef=database.ref().child('informacion_empresa');
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleUpload=this.handleUpload.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.handleSubmit();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
	}
	
	handleClickAlerta(event){
		this.setState({
			template:true			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	async componentDidMount(){
		
		this.informacionRef.on('value',this.gotData,this.errData);

			const snapViajes    = await database.ref('AsignacionViajes').once('value');
			const viajes        = snapViajes.val();

			const snapVehiculos = await database.ref('Vehiculos').once('value');
			const vehiculos     = snapVehiculos.val();

			console.log('Object.keys(viajes).length :', Object.keys(viajes).length);
			// for (const idViaje in viajes) {

			// 	for (const idVehiculo in vehiculos) {
			// 		const arrViaje =String(viajes[idViaje].movil).split('-');
			// 		if(arrViaje[0]=='EQ')
			// 			viajes[idViaje].movil=`E-${arrViaje[1]}`;
			// 		if(viajes[idViaje].movil=="EQ-32") viajes[idViaje].movil='M-32';

			// 		if(viajes[idViaje].movil && viajes[idViaje].movil==vehiculos[idVehiculo].movil){

			// 			if(viajes[idViaje].movil=='M-32'){
			// 				database.ref().child('AsignacionViajes').child(idViaje).update({vehiculo:idVehiculo})
			// 				.then(() => {
			// 					console.log('valor')
			// 				})
			// 				.catch(error =>{
			// 					console.log(error)
			// 				})
			// 			}
			// 			break;
			// 		}
			// 	}
			// }
			
	}
	
	gotData = (data) => {
		  
		  const informacionData = data.val();
		  
			 
		  
		  
			this.nombreEmpresa.value=informacionData['informacion'].nombre;
			this.direccionEmpresa.value=informacionData['informacion'].direccion;
			this.visionEmpresa.value=informacionData['informacion'].vision;
			this.misionEmpresa.value=informacionData['informacion'].mision;
			this.setState({ 
				 logo:informacionData['informacion'].logo
				 
			}); 
		}
		errData = (err) => {
			console.log(err);
		}
	
	
		handleSubmit(){
		
	
		let nombre=this.nombreEmpresa.value;
		let direccion=this.direccionEmpresa.value;
		let vision=this.visionEmpresa.value;
		let mision=this.misionEmpresa.value;
	
		
		let archivo=this.state.files;
		
		if(this.state.files===null){

				this.informacionRef.child('informacion').update({
							
							nombre:nombre,
							direccion:direccion,
							mision:mision,
							vision:vision,
									
				});
			
				Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
			
		}
		else{
				
				
				const storageRef = firebase.storage().ref(`Empleados/${archivo.name}`);
				
				const task= storageRef.put(archivo);
				
				task.on('state_changed', snapshot =>{
				
				
				this.setState({
				  uploadValue :50,
				})

				}, error =>{ console.log(error.message);
				},
				()=>{
					
					
			
					this.informacionRef.child('informacion').update({
						
						nombre:nombre,
						direccion:direccion,
						mision:mision,
						vision:vision,
						logo:task.snapshot.downloadURL
								
					});
					
				
					this.setState({
						uploadValue:100
					});
					
				
					Alert.success('Datos guardados correctamente', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});

				});
		
		}
			
	}
	
	
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 logo:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					alert('Por favor ingresa una imagen con formato valido');
					return;
				}
		


				reader.onload = (e) => {
					this.setState({ 
						logo:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);
						
		}

		
		
		
	}
	
	
		ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	
	render(){
		
		return(
		
			<div className="Informacion container" onClick={this.ocultarMenu}>
				
					
					{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido.bind(this)}/>:<Alert stack={{limit: 3}} html={true} />}

					<div className="row cn">
						<div className="col-md-12">
							<h1 className="titulo">Información</h1>
							<form method="POST" action="" onSubmit={this.handleClickAlerta}>
								
								<div className="form-group">
									<label htmlFor="nombreEmpresa">Nombre de la empresa:</label>
									<input type="text" name="nombreEmpresa" className="form-control" 
									placeholder="Nombre Empresa" ref={input=>{this.nombreEmpresa=input;}}
									required autoComplete="off"
						
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="direcccionEmpresa">Dirección:</label>
									<input type="text" name="direcccionEmpresa" className="form-control" 
									placeholder="Dirección Empresa" 
									ref={input=>{this.direccionEmpresa=input;}}
									required autoComplete="off"
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="foto">Logo de la empresa</label>
									<br/>
									<progress value={this.state.uploadValue} max="100"></progress>
									<input type="file" className="form-control"  onChange={this.handleUpload}/>
								    <img src={this.state.logo} alt="Logo empresa" className="foto" width="240px"
											
									/>
								</div>

								
								<div className="form-group">
									<label htmlFor="mision">Mision:</label>
									<textarea className="form-control" placeholder="Misión..." 
									ref={input=>{this.misionEmpresa=input;}}
									required autoComplete="off" rows="6"
									></textarea>
									
								</div>
								
								<div className="form-group">
									<label htmlFor="vision">Vision:</label>
									<textarea className="form-control" placeholder="Visión..." 
									ref={input=>{this.visionEmpresa=input;}}
									required autoComplete="off" rows="6"
									></textarea>
								</div>
								
								<div className="form-group">
									<button type="submit" className="btn btn-success">Modificar</button>
								</div>
							
							</form>
						</div>
					</div>
				
				
			
			</div>
		
		
		
		);
		
	}
}

export default Informacion;


// WEBPACK FOOTER //
// ./src/Components/Informacion/Informacion.jsx